import Profile from './Profile';
import './style/index.less';

export * from './Profile';

export default Profile;
